export const toDisplayScore = (score: number): number =>
	Math.min(10, Math.max(1, Math.round((score + 1) * 10) / 10));

export const formatDisplayScore = (score: number): string => String(Math.round(score * 10) / 10);
